(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimek-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAPE_MS = 400;
    var DELAY = TAPE_MS + 1;
    var DURATION = 3200;
    var STRIPS = 150;
    var BAND = 0.34;

    function noiseTile() {
      var tile = document.createElement('canvas');
      tile.width = 128;
      tile.height = 128;
      var c = tile.getContext('2d');
      for (var y = 0; y < 128; y += 3) {
        for (var x = 0; x < 128; x += 3) {
          c.fillStyle = 'rgba(0,0,0,' + (0.25 + Math.random() * 0.75).toFixed(3) + ')';
          c.fillRect(x, y, 3, 3);
        }
      }
      return tile;
    }

    function burst(section, img) {
      var rect = img.getBoundingClientRect();
      var host = img.parentNode.getBoundingClientRect();
      var cs = window.getComputedStyle(img);
      var padL = parseFloat(cs.paddingLeft) || 0;
      var padR = parseFloat(cs.paddingRight) || 0;
      var padT = parseFloat(cs.paddingTop) || 0;
      var padB = parseFloat(cs.paddingBottom) || 0;

      var cw = rect.width - padL - padR;
      var ch = rect.height - padT - padB;
      if (cw <= 0 || ch <= 0) return;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var canvas = document.createElement('canvas');
      canvas.className = 'klimek-signup__burst';
      canvas.width = Math.round(cw * dpr);
      canvas.height = Math.round(ch * dpr);
      canvas.style.left = (rect.left - host.left + padL) + 'px';
      canvas.style.top = (rect.top - host.top + padT) + 'px';
      canvas.style.width = cw + 'px';
      canvas.style.height = ch + 'px';
      img.parentNode.insertBefore(canvas, img.nextSibling);

      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      var pattern = ctx.createPattern(noiseTile(), 'repeat');

      var ratio = img.naturalWidth / img.naturalHeight;
      var dw = cw;
      var dh = cw / ratio;
      if (dh > ch) {
        dh = ch;
        dw = ch * ratio;
      }
      var dx = (cw - dw) / 2;
      var dy = (ch - dh) / 2;
      var stripH = dh / STRIPS;
      var srcH = img.naturalHeight / STRIPS;

      var jitter = [];
      var sway = [];
      for (var j = 0; j < STRIPS; j++) {
        jitter.push((Math.random() - 0.5) * 0.14);
        sway.push((Math.random() - 0.5) * 2);
      }

      img.style.opacity = '0';

      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var p = Math.min(1, Math.max(0, (now - start - DELAY) / DURATION));
        var front = (1 + BAND) * (1 - Math.pow(1 - p, 1.45));

        ctx.clearRect(0, 0, cw, ch);

        for (var i = 0; i < STRIPS; i++) {
          var top = i / STRIPS;
          var local = (front - top) / BAND + jitter[i];
          if (local >= 1) continue;
          if (local < 0) local = 0;

          var eased = local * local;
          var lift = eased * dh * 0.2;
          var drift = sway[i] * eased * 22;
          var y = dy + top * dh - lift;

          ctx.globalCompositeOperation = 'source-over';
          ctx.globalAlpha = 1;
          ctx.drawImage(img, 0, i * srcH, img.naturalWidth, srcH, dx + drift, y, dw, stripH + 2);

          if (local > 0) {
            ctx.globalCompositeOperation = 'destination-out';
            ctx.globalAlpha = Math.min(1, local * 2.2);
            ctx.fillStyle = pattern;
            ctx.fillRect(dx + drift - 40, y, dw + 80, stripH + 2);
            if (local > 0.5) {
              ctx.globalAlpha = (local - 0.5) / 0.5;
              ctx.fillStyle = '#000';
              ctx.fillRect(dx + drift - 40, y, dw + 80, stripH + 2);
            }
          }
        }

        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          canvas.parentNode.removeChild(canvas);
        }
      }
      requestAnimationFrame(frame);
    }

    /* Alle Folien liegen uebereinander im Bildausschnitt. "lazy" haelt sie
       deshalb nicht zurueck — sie wuerden alle sofort geladen und die erste
       Ansicht unnoetig schwer machen. Darum traegt das Skript sie nach:
       erst wenn die Seite steht, und dann eine nach der anderen. */
    function nachladen(section) {
      var offen = [].slice.call(section.querySelectorAll('[data-klimek-spaet]'));
      if (!offen.length) return;

      function naechste() {
        var bild = offen.shift();
        if (!bild) return;
        bild.addEventListener('load', naechste, { once: true });
        bild.addEventListener('error', naechste, { once: true });
        var satz = bild.getAttribute('data-klimek-spaet-satz');
        if (satz) bild.setAttribute('srcset', satz);
        bild.setAttribute('src', bild.getAttribute('data-klimek-spaet'));
        bild.removeAttribute('data-klimek-spaet');
        bild.removeAttribute('data-klimek-spaet-satz');
      }

      if (document.readyState === 'complete') naechste();
      else window.addEventListener('load', naechste, { once: true });
    }

    function rotate(section) {
      var slides = section.querySelectorAll('.klimek-signup__product');
      if (slides.length < 2) return;

      var every = parseInt(section.getAttribute('data-klimek-interval'), 10);
      if (!every || every < 1000) every = 4000;

      var i = 0;
      var timer = setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, every);

      section.addEventListener('klimek:stop', function () { clearInterval(timer); });
    }

    function dissolve(marker) {
      var section = marker.closest('.klimek-signup');
      if (!section) return;

      section.dispatchEvent(new Event('klimek:stop'));

      var img = section.querySelector('.klimek-signup__product.is-active') ||
                section.querySelector('.klimek-signup__product');
      if (!img) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        img.style.transition = 'opacity 0.6s linear 0.55s';
        img.style.opacity = '0';
        return;
      }

      if (img.complete && img.naturalWidth) {
        burst(section, img);
      } else {
        img.addEventListener('load', function () { burst(section, img); });
      }
    }

    function pruefung(section) {
      var form = section.querySelector('.klimek-signup__form');
      if (!form) return;
      var feld = form.querySelector('input[type="email"]');
      if (!feld) return;

      var standard = feld.getAttribute('placeholder') || '';
      var meldung = section.getAttribute('data-klimek-fehler') || 'BITTE E-MAIL-ADRESSE PRUEFEN';

      form.addEventListener('submit', function (e) {
        var wert = feld.value.trim();
        var gueltig = wert.length > 4 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert);
        if (gueltig) return;
        e.preventDefault();
        feld.value = '';
        feld.setAttribute('placeholder', meldung);
        feld.classList.add('is-fehler');
        feld.focus();
      });

      feld.addEventListener('input', function () {
        if (!feld.classList.contains('is-fehler')) return;
        feld.classList.remove('is-fehler');
        feld.setAttribute('placeholder', standard);
      });
    }

    function init() {
      var markers = document.querySelectorAll('[data-klimek-dissolve]');
      for (var i = 0; i < markers.length; i++) dissolve(markers[i]);

      var sections = document.querySelectorAll('.klimek-signup');
      for (var j = 0; j < sections.length; j++) {
        pruefung(sections[j]);
        nachladen(sections[j]);
        if (!sections[j].querySelector('[data-klimek-dissolve]')) rotate(sections[j]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimek-produkt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Einblenden der unteren Abschnitte */
    function einblenden(wurzel) {
      var ziele = wurzel.querySelectorAll('[data-zeigen]');
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < ziele.length; i++) ziele[i].classList.add('is-sichtbar');
        return;
      }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-sichtbar');
          beobachter.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      for (var j = 0; j < ziele.length; j++) beobachter.observe(ziele[j]);
    }

    /* Punkte unter der Galerie. Gescrollt wird vom Browser — hier wird nur
       abgelesen, bei welchem Bild er steht. */
    function galerie(wurzel) {
      var spur = wurzel.querySelector('[data-galerie]');
      var punkte = wurzel.querySelector('[data-punkte]');
      if (!spur || !punkte) return;
      var rahmen = spur.querySelectorAll('.klimek-pd__rahmen');
      if (rahmen.length < 2) return;

      for (var i = 0; i < rahmen.length; i++) {
        var pkt = document.createElement('span');
        pkt.className = 'klimek-pd__punkt' + (i === 0 ? ' is-da' : '');
        punkte.appendChild(pkt);
      }
      var alle = punkte.children;
      var warte = false;
      function ablesen() {
        warte = false;
        var index = Math.round(spur.scrollLeft / spur.clientWidth);
        for (var k = 0; k < alle.length; k++) alle[k].classList.toggle('is-da', k === index);
      }
      spur.addEventListener('scroll', function () {
        if (warte) return;
        warte = true;
        window.requestAnimationFrame(ablesen);
      }, { passive: true });
    }

    /* Die Kaufleiste zeigt dasselbe Teil wie oben. Sie spiegelt die
       Groessenkacheln, damit unten nicht erneut gewaehlt werden muss. */
    function leiste(wurzel) {
      var bar = wurzel.querySelector('[data-leiste]');
      var form = wurzel.querySelector('.klimek-pd__form');
      if (!bar || !form) return;
      var feld = bar.querySelector('[data-leiste-groesse]');
      var preisOben = wurzel.querySelector('[data-preis-anzeige]');
      var preisUnten = bar.querySelector('[data-leiste-preis]');

      function spiegeln() {
        var quellen = form.querySelectorAll('.klimek-p__radio');
        while (feld.childNodes.length > 1) feld.removeChild(feld.lastChild);
        for (var i = 0; i < quellen.length; i++) {
          var q = quellen[i];
          var kennung = 'leiste-' + q.value;
          var knopf = document.createElement('input');
          knopf.type = 'radio';
          knopf.name = 'id';
          knopf.className = 'klimek-p__radio';
          knopf.id = kennung;
          knopf.value = q.value;
          knopf.disabled = q.disabled;
          knopf.checked = q.checked;
          var kachel = document.createElement('label');
          kachel.className = 'klimek-p__chip' + (q.disabled ? ' klimek-p__chip--weg' : '');
          kachel.setAttribute('for', kennung);
          kachel.appendChild(document.createTextNode(q.getAttribute('data-titel') || q.value));
          if (q.disabled) {
            var zusatz = document.createElement('span');
            zusatz.className = 'klimek-versteckt';
            zusatz.textContent = ' — ausverkauft';
            kachel.appendChild(zusatz);
          }
          feld.appendChild(knopf);
          feld.appendChild(kachel);
        }
        var gewaehlt = feld.querySelector('.klimek-p__radio:checked');
        if (gewaehlt) {
          var dazu = feld.querySelector('label[for="' + gewaehlt.id + '"]');
          if (dazu) feld.scrollLeft = Math.max(0, dazu.offsetLeft - feld.clientWidth / 2 + dazu.offsetWidth / 2);
        }
      }
      spiegeln();

      /* Preis folgt der Groesse, wo sich die Varianten unterscheiden. Beide
         Richtungen, damit oben und unten nie auseinanderlaufen. */
      wurzel.addEventListener('change', function (e) {
        var ziel = e.target;
        if (!ziel.classList || !ziel.classList.contains('klimek-p__radio')) return;
        var imFormular = form.contains(ziel);
        if (imFormular) {
          var spiegel = feld.querySelector('input[value="' + ziel.value + '"]');
          if (spiegel) spiegel.checked = true;
        } else {
          var original = form.querySelector('input[value="' + ziel.value + '"]');
          if (original) original.checked = true;
        }
        var preis = (imFormular ? ziel : form.querySelector('input[value="' + ziel.value + '"]') || ziel)
          .getAttribute('data-preis');
        if (preis) {
          if (preisOben) preisOben.textContent = preis;
          if (preisUnten) preisUnten.textContent = preis;
          wurzel.setAttribute('data-preis', preis);
        }
      });

      /* Die Leiste erscheint, sobald der obere Kaufknopf aus dem Bild ist. */
      var oben = form.querySelector('button[type="submit"]');
      if (!oben || !('IntersectionObserver' in window)) { bar.classList.add('is-da'); return; }
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          bar.classList.toggle('is-da', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(oben);
    }

    /* Groesse ueber einen Regler statt ueber Kacheln. Die Kacheln bleiben im
       Quelltext und tragen weiterhin das Feld, das verschickt wird — der
       Regler schaltet nur zwischen ihnen um. Ohne Skript bleibt es bei den
       Kacheln, es geht also nichts verloren. */
    function regler(wurzel) {
      var kasten = wurzel.querySelector('[data-regler]');
      var form = wurzel.querySelector('.klimek-pd__form');
      if (!kasten || !form) return;

      var schieber = kasten.querySelector('[data-regler-schieber]');
      var wert = kasten.querySelector('[data-regler-wert]');
      var fuellung = kasten.querySelector('[data-regler-fuellung]');
      var marken = kasten.querySelectorAll('.klimek-pd__stufe');
      var knoepfe = form.querySelectorAll('.klimek-p__radio');
      var kacheln = form.querySelector('.klimek-p__wahl');
      if (!schieber || knoepfe.length < 2) return;

      /* Erst jetzt umschalten: Bis hierher war der Regler verborgen und die
         Kacheln sichtbar — faellt das Skript aus, bleibt es dabei. */
      kasten.hidden = false;
      if (kacheln) kacheln.hidden = true;

      function setzen(index, melden) {
        var knopf = knoepfe[index];
        if (!knopf) return;
        var titel = knopf.getAttribute('data-titel') || knopf.value;
        var weg = knopf.disabled;

        wert.textContent = weg ? titel + ' — ausverkauft' : titel;
        wert.classList.toggle('klimek-pd__reglerwert--weg', weg);
        /* Vorleseprogramme sollen die Groesse hoeren, nicht die Nummer. */
        schieber.setAttribute('aria-valuetext', weg ? titel + ', ausverkauft' : titel);

        var anteil = knoepfe.length > 1 ? index / (knoepfe.length - 1) : 0;
        fuellung.style.width = (anteil * 100) + '%';
        for (var i = 0; i < marken.length; i++) marken[i].classList.toggle('is-da', i === index);

        if (!weg) {
          knopf.checked = true;
          /* Loest den vorhandenen Weg aus: Preis oben und unten nachziehen
             und die Kachel in der Kaufleiste mitwaehlen. */
          if (melden) knopf.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var kaufen = form.querySelector('button[type="submit"]');
        if (kaufen) {
          kaufen.disabled = weg;
          kaufen.textContent = weg
            ? kaufen.getAttribute('data-ausverkauft') || kaufen.textContent
            : kaufen.getAttribute('data-kaufen') || kaufen.textContent;
        }
      }

      /* Startwert ist die Groesse, die bereits gewaehlt ist. */
      var start = 0;
      for (var k = 0; k < knoepfe.length; k++) if (knoepfe[k].checked) start = k;
      schieber.value = start;
      setzen(start, false);

      schieber.addEventListener('input', function () { setzen(parseInt(schieber.value, 10), true); });
    }

    function start() {
      var wurzeln = document.querySelectorAll('.klimek-pd');
      for (var i = 0; i < wurzeln.length; i++) {
        einblenden(wurzeln[i]);
        galerie(wurzeln[i]);
        leiste(wurzeln[i]);
        regler(wurzeln[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimek-produkte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function einblenden(wurzel) {
      /* Unterstuetzt der Browser scroll-getriebene Animationen, erledigt das
         CSS die Einblendung. Der Beobachter liefe dann doppelt. */
      if (CSS.supports && CSS.supports('animation-timeline', 'view()')) return;
      var ziele = wurzel.querySelectorAll('[data-zeigen]');
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < ziele.length; i++) ziele[i].classList.add('is-sichtbar');
        return;
      }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-sichtbar');
          beobachter.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      for (var j = 0; j < ziele.length; j++) beobachter.observe(ziele[j]);
    }

    /* ---------- Bilder der Buehne erst laden, wenn sie drankommen ----------
       Alle sechs Teile stehen technisch im Bildausschnitt, "lazy" allein laedt
       sie deshalb sofort alle. Geladen wird das aktive Teil und zwei voraus —
       genug Vorlauf, dass beim Scrollen nichts nachhinkt. */
    function bildLaden(teil) {
      if (!teil || teil.dataset.geladen) return;
      var bilder = teil.querySelectorAll('img[data-spaet]');
      /* Einmal gemerkt, damit der Scrollrechner nicht bei jedem Bild erneut
         durch alle Teile sucht. */
      teil.dataset.geladen = '1';
      for (var i = 0; i < bilder.length; i++) {
        var bild = bilder[i];
        var satz = bild.getAttribute('data-spaet-satz');
        if (satz) bild.setAttribute('srcset', satz);
        bild.setAttribute('src', bild.getAttribute('data-spaet'));
        bild.removeAttribute('data-spaet');
        bild.removeAttribute('data-spaet-satz');
      }
    }

    /* ---------- Warenkorb ohne Seitenneuladen ----------
       Ohne das laedt nach jedem Kauf die ganze Seite neu, der Besucher landet
       wieder oben und muss zurueckscrollen — bei einer Seite, die vom Scrollen
       lebt, der einzige echte Bruch. Gibt es keine Warenkorbschublade im Theme
       oder scheitert die Anfrage, geht das Formular den gewoehnlichen Weg. */
    function leiste(wurzel) {
      var bar = wurzel.querySelector('[data-leiste]');
      var waren = Array.prototype.slice.call(wurzel.querySelectorAll('[data-ware]'));
      if (!bar || !waren.length) return;

      var feldName = bar.querySelector('[data-leiste-name]');
      var feldPreis = bar.querySelector('[data-leiste-preis]');
      var feldGroesse = bar.querySelector('[data-leiste-groesse]');
      var knopf = bar.querySelector('button[type="submit"]');
      var spur = wurzel.querySelector('.klimek-b__spur');
      var aktuell = -1;

      function kachelnBauen(ware) {
        /* Die Leiste spiegelt die Groessen des aktiven Teils. Eigene Kennungen,
           damit die Beschriftungen nicht auf die Knoepfe des Teils zeigen. */
        var quellen = ware.querySelectorAll('.klimek-p__radio');
        while (feldGroesse.childNodes.length > 1) feldGroesse.removeChild(feldGroesse.lastChild);
        for (var i = 0; i < quellen.length; i++) {
          var q = quellen[i];
          var kennung = 'leiste-groesse-' + q.value;
          var knopfchen = document.createElement('input');
          knopfchen.type = 'radio';
          knopfchen.name = 'id';
          knopfchen.className = 'klimek-p__radio';
          knopfchen.id = kennung;
          knopfchen.value = q.value;
          knopfchen.disabled = q.disabled;
          knopfchen.checked = q.checked;
          var kachel = document.createElement('label');
          kachel.className = 'klimek-p__chip' + (q.disabled ? ' klimek-p__chip--weg' : '');
          kachel.setAttribute('for', kennung);
          /* Nur der reine Groessenname. Der sichtbare Text der Vorlage enthaelt
             zusaetzlich den Hinweis "ausverkauft", der dort ausschliesslich
             fuer Vorleseprogramme steht — abgeschrieben blaeht er die Kachel
             auf das Vierfache auf. */
          kachel.appendChild(document.createTextNode(q.getAttribute('data-titel') || q.value));
          if (q.disabled) {
            var zusatz = document.createElement('span');
            zusatz.className = 'klimek-versteckt';
            zusatz.textContent = ' — ausverkauft';
            kachel.appendChild(zusatz);
          }
          feldGroesse.appendChild(knopfchen);
          feldGroesse.appendChild(kachel);
        }
      }

      function uebernehmen(index) {
        if (index === aktuell || !waren[index]) return;
        aktuell = index;
        var ware = waren[index];

        feldName.textContent = ware.getAttribute('data-name') || '';
        feldPreis.textContent = ware.getAttribute('data-preis') || '';
        kachelnBauen(ware);

        /* Die gewaehlte Kachel ins Bild holen: In der Leiste passen nicht alle
           Groessen nebeneinander, und ausgerechnet die ausgewaehlte stand
           sonst manchmal ausserhalb. */
        var gewaehlt = feldGroesse.querySelector('.klimek-p__radio:checked');
        if (gewaehlt) {
          var kachelDazu = feldGroesse.querySelector('label[for="' + gewaehlt.id + '"]');
          if (kachelDazu) {
            feldGroesse.scrollLeft = Math.max(0, kachelDazu.offsetLeft - feldGroesse.clientWidth / 2 + kachelDazu.offsetWidth / 2);
          }
        }

        var lieferbar = ware.getAttribute('data-lieferbar') !== 'nein';
        knopf.disabled = !lieferbar;
        knopf.textContent = lieferbar
          ? bar.getAttribute('data-kaufen')
          : bar.getAttribute('data-ausverkauft');
      }

      if (spur) {
        /* Auf der Buehne stehen alle Teile gleichzeitig im Bild, ein
           Sichtbarkeitsbeobachter meldet deshalb alle auf einmal. Das aktive
           Teil ergibt sich stattdessen aus dem Fortschritt durch die Spur.
           Waehrend der Buehne bleibt die Leiste unten, weil dort bereits
           gekauft werden kann; danach begleitet sie das zuletzt gesehene
           Teil durch die Detailabschnitte. */
        var warte = false;
        var pruefen = function () {
          warte = false;
          var kasten = spur.getBoundingClientRect();
          var weg = kasten.height - window.innerHeight;
          var fortschritt = weg > 0 ? Math.min(Math.max(-kasten.top / weg, 0), 1) : 0;
          var index = Math.min(Math.floor(fortschritt * waren.length), waren.length - 1);
          uebernehmen(index);
          /* Bis zwei Teile voraus, und alles davor mit: Springt jemand mit
             der Bildlaufleiste mitten hinein, blieben uebersprungene Teile
             sonst ohne Bild. Geladenes meldet sich nicht noch einmal. */
          for (var k = 0; k <= index + 2 && k < waren.length; k++) bildLaden(waren[k]);
          bar.classList.toggle('is-da', kasten.bottom < window.innerHeight * 0.5);
        };
        var anstossen = function () {
          if (warte) return;
          warte = true;
          window.requestAnimationFrame(pruefen);
        };
        window.addEventListener('scroll', anstossen, { passive: true });
        window.addEventListener('resize', anstossen, { passive: true });
        pruefen();
        return;
      }

      /* Ohne Buehne: das Teil melden, das gerade im Bild steht. */
      if (!('IntersectionObserver' in window)) { uebernehmen(0); return; }
      var sichtbar = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) uebernehmen(waren.indexOf(e.target));
        });
      }, { threshold: 0.35 });
      waren.forEach(function (w) { sichtbar.observe(w); });

      var schalter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          bar.classList.toggle('is-da', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      schalter.observe(waren[0]);
      uebernehmen(0);
    }

    /* Preis folgt der gewaehlten Groesse, wo sich die Varianten im Preis
       unterscheiden. */
    function preisNachziehen(wurzel) {
      wurzel.addEventListener('change', function (ereignis) {
        var knopf = ereignis.target;
        if (!knopf.classList || !knopf.classList.contains('klimek-p__radio')) return;
        var preis = knopf.getAttribute('data-preis');
        var ware = knopf.closest ? knopf.closest('[data-ware]') : null;
        if (!ware || !preis) return;
        var anzeige = ware.querySelector('.klimek-p__preis, .klimek-b__preis');
        if (anzeige) anzeige.textContent = preis;
        ware.setAttribute('data-preis', preis);

        /* Die Leiste nur dann mitziehen, wenn sie dieses Teil zeigt. Sonst
           bekam sie den Preis eines Teils, das gar nicht in ihr steht. */
        var leisteName = wurzel.querySelector('[data-leiste-name]');
        var leistePreis = wurzel.querySelector('[data-leiste-preis]');
        if (leisteName && leistePreis && leisteName.textContent === (ware.getAttribute('data-name') || '')) {
          leistePreis.textContent = preis;
        }
      });
    }

    function start() {
      var wurzeln = document.querySelectorAll('.klimek-p');
      for (var i = 0; i < wurzeln.length; i++) {
        einblenden(wurzeln[i]);
        leiste(wurzeln[i]);
        preisNachziehen(wurzeln[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
